import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-summary-item',
  templateUrl: './shared-summary-item.component.html',
  styleUrls: ['./shared-summary-item.component.scss'],
})
export class SharedSummaryItemComponent {
  @Input() item_label?: string;
  @Input() item_value?: string;
  @Input() value_suffix?: string;
  @Input() item_class?: string = 'sp-background__accent-contrast';
  @Input() label_class?: string = 'sp-color__primary';
  @Input() value_class?: string = 'sp-color__primary';
  @Input() is_summary_request_running?: boolean = false;
}
